/**
 * Knowledge Hub RAG API — sources, documents, upload, search, stats, reindex.
 */

import { apiFetch } from './core'

export const knowledgeApi = {
    listSources: () => apiFetch('/knowledge/sources'),
    createSource: (data) => apiFetch('/knowledge/sources', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    updateSource: (id, data) => apiFetch(`/knowledge/sources/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    }),
    deleteSource: (id) => apiFetch(`/knowledge/sources/${id}`, { method: 'DELETE' }),

    listDocuments: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/knowledge/documents${qs ? `?${qs}` : ''}`)
    },
    uploadDocument: (sourceId, file, { accessRules, numQuestions, folderId } = {}) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('source_id', sourceId)
        if (folderId) formData.append('folder_id', folderId)
        if (numQuestions) formData.append('num_questions', String(numQuestions))
        if (accessRules) formData.append('access_rules_json', JSON.stringify(accessRules))
        return apiFetch('/knowledge/documents/upload', {
            method: 'POST',
            body: formData,
        })
    },
    deleteDocument: (id) => apiFetch(`/knowledge/documents/${id}`, { method: 'DELETE' }),
    reindexDocument: (id) => apiFetch(`/knowledge/documents/${id}/reindex`, { method: 'POST' }),

    search: (query, topK = 5) => apiFetch('/knowledge/search', {
        method: 'POST',
        body: JSON.stringify({ query, top_k: topK }),
    }),

    stats: () => apiFetch('/knowledge/stats'),
    reindexWiki: () => apiFetch('/knowledge/reindex-wiki', { method: 'POST' }),

    listFolders: (sourceId) => apiFetch(`/knowledge/folders${sourceId ? `?source_id=${sourceId}` : ''}`),
    createFolder: (data) => apiFetch('/knowledge/folders', { method: 'POST', body: JSON.stringify(data) }),
    updateFolder: (id, data) => apiFetch(`/knowledge/folders/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
    deleteFolder: (id) => apiFetch(`/knowledge/folders/${id}`, { method: 'DELETE' }),
    moveDocument: (id, folderId) => apiFetch(`/knowledge/documents/${id}/move`, { method: 'PATCH', body: JSON.stringify({ folder_id: folderId }) }),
    bulkMoveDocuments: (documentIds, folderId) => apiFetch('/knowledge/documents/bulk-move', {
        method: 'POST',
        body: JSON.stringify({ document_ids: documentIds, folder_id: folderId }),
    }),
}
